/**
 * Skip to Content Link - Accessibility improvement for keyboard navigation
 * Allows users to skip past navigation directly to main content
 */
const SkipToContent = () => {
  return (
    <a
      href="#main-content"
      className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-[100] focus:px-4 focus:py-2 focus:bg-warm-gold focus:text-white focus:rounded-lg focus:font-semibold focus:outline-none focus:ring-2 focus:ring-warm-gold focus:ring-offset-2"
    >
      Skip to main content
    </a>
  );
};

export default SkipToContent;
